import {Checkbox} from "@fluentui/react";
import React from "react";

interface IsaacCheckBoxProps {
  newValue: boolean;
  handleValueChanged: (checked: boolean) => void;
}

const IsaacCheckBox: React.FunctionComponent<IsaacCheckBoxProps> = ({newValue, handleValueChanged}) => {
  return (
    <Checkbox
      disabled={false}
      checked={newValue}
      onChange={(_, checked) => {
        handleValueChanged(!!checked);
      }}
    />
  );
};

export default IsaacCheckBox;
